//@flow

/*
The Flux data store for maintaining local state
*/

import {
  OrderedMap,
} from 'immutable';

import {
  ReduceStore
} from 'flux/utils';

import Dispatcher from 'app/Dispatcher';
import ActionTypes from './ActionTypes';


class NotifierStore extends ReduceStore < Object > {
  constructor() {
    super(Dispatcher);
  }

  getInitialState(): Object {
    return OrderedMap();
  }

  reduce(state: Object, action: Object): Object {
    switch (action.type) {

      case ActionTypes.PUSH_NOTIFICATION:
        return state.set(action.notification.id, action.notification)



      case ActionTypes.DROP_NOTIFICATION:
        return state.delete(action.id)

      default:
        return state;
    }
  }
}

export default new NotifierStore();